import * as React from 'react';
import './working-hours-label.scss';
import { ReactComponent as TickCircleIcon } from '../../../assets/icons/tickcircle.svg';
import { ReactComponent as InfoCircleIcon } from '../../../assets/icons/infocircle.svg';

interface Props {
  leftText?: string;
  rightText?: string;
  icon?: string;
}

const WorkingHoursLabel: React.FC<Props> = ({ leftText, rightText, icon }) => {
  return (
    <div className="working-hours-label">
      <div className="working-hours-label__text">{leftText}</div>

      <div className="working-hours-label__setting">
        {/* {icon === 'tick' && <TickCircleIcon />}
        {icon === 'info' && <InfoCircleIcon color="#E47C77" />}
        <div className="working-hours-label__setting__text">{rightText}</div> */}
      </div>
    </div>
  );
};
export default WorkingHoursLabel;
